import React from 'react';
import { Flex, Text } from '@adobe/react-spectrum';
import { CardTypeIcon } from './CardTypeIcon';
import './cardStats.css';

export function CardStatRow({ card, deckCount, onSelectCard, compact = false }) {
    const inclusionRate = card?.inclusionRate || 0;
    const pct = Math.round(inclusionRate * 100);
    const name = card?.name || card?.cardId || card?.id || 'Unknown';
    const imageUri = card?.imageUri;

    const cardId = card?.cardId || card?.id;
    const handleClick = () => {
        if (onSelectCard && cardId) {
            onSelectCard({ id: cardId, cardId, name, imageUri, types: card?.types });
        }
    };

    return (
        <Flex
            direction="row"
            alignItems="center"
            columnGap={10}
            UNSAFE_className={`cardStatRow ${compact ? 'cardStatRowCompact' : ''}`}
        >
            {imageUri ? (
                <img
                    src={imageUri}
                    alt={name}
                    className="cardStatThumb"
                    onClick={handleClick}
                    loading="lazy"
                />
            ) : (
                <div className="cardStatThumbPlaceholder" />
            )}
            <CardTypeIcon types={card?.types} />
            <span
                className="cardStatName"
                onClick={handleClick}
                style={{ cursor: cardId ? 'pointer' : 'default' }}
                title={cardId ? `Click to view ${name}` : name}
            >
                {name}
            </span>
            <div className="cardStatBarTrack">
                <div className="cardStatBarFill" style={{ width: `${Math.max(pct, 1)}%` }} />
            </div>
            <Text UNSAFE_className="cardStatPercent">{`${pct}%`}</Text>
            <Text UNSAFE_className="cardStatCount">{`${card.count}/${deckCount}`}</Text>
        </Flex>
    );
}
